import { clsx } from 'clsx'
import { badgeVariants, containerStyle } from './index.css'

export const NotificationBadge = (props: {
  count: number
  className?: string
  variant?: keyof typeof badgeVariants
  children: React.ReactNode
}) => {
  return (
    <div className={clsx(containerStyle, props.className)}>
      {props.children}
      {props.count > 0 ? (
        <span className={badgeVariants[props.variant ?? 'primary']}>
          {props.count > 99 ? '99+' : props.count}
        </span>
      ) : null}
    </div>
  )
}
